import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rciq_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response) {
      const status = err.response.status;
      const detail = err.response.data?.detail || "";
      // 401 → expired/invalid session. Force-logout.
      // 403 + "disabled" → admin deactivated the account. Force-logout.
      const isDisabled = status === 403 && typeof detail === "string" && /disabled|session ended/i.test(String(detail));
      if (status === 401 || isDisabled) {
        localStorage.removeItem("rciq_token");
        localStorage.removeItem("rciq_user");
        if (window.location.pathname !== "/login" && !window.location.pathname.startsWith("/reset-password")) {
          const msg = isDisabled ? "Your account has been disabled. Please contact your administrator." : "";
          if (msg) sessionStorage.setItem("rciq_login_message", msg);
          window.location.href = "/login";
        }
      }
      // PLAN_LOCKED / SEAT_CAP_REACHED come through as objects in `detail` so existing
      // toast.error(err?.response?.data?.detail) calls would render [object Object].
      // Normalise to the inner `message` string while preserving the structured
      // payload at `err.response.data._planLock` for components that want to render
      // an UpgradeCard inline (see parsePlanLockError in components/UpgradeCard.jsx).
      if (status === 403 && detail && typeof detail === "object" && detail.error) {
        err.response.data._planLock = detail;
        err.response.data.detail = detail.message || "Upgrade required.";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
